<template>
	<div>
  <v-card-title>
    <v-text-field
      v-model="search"
      append-icon="mdi-magnify"
      label="Buscar"
      single-line
      hide-details
    ></v-text-field>
  </v-card-title>
  <v-data-table
    :headers="headers"
    :items="array_docs"
    sort-by="documento"
    :search="search"
    class="elevation-1"
  >
    <template v-slot:item.actions="{ item }">
      
    <!--<v-btn color="warning" fab x-small class="mx-2" title="Firmar" 
        :to="{ name: 'expediente_documento_edit', params: {opt: 'firmar', id: item.id}}">
        <v-icon>mdi-draw</v-icon>
      </v-btn> 
    -->
      <v-btn :disabled="!item.paqueteId > 0" color="info" fab x-small class="mx-2" title="Visualizar"
        :to="{'name': 'expediente_flujo_opt', params: {'opt': 'detalle', 'flujo': item}}">
        <v-icon>mdi-eye-check-outline</v-icon>
      </v-btn>
      <v-btn color="error" fab x-small class="mx-2" title="Eliminar"
        :disabled="item.creado_por != $store.state.user.email"
        @click="deleteDocument(item.id, item.nombre_archivo)">
        <v-icon>mdi-delete-alert-outline</v-icon>
      </v-btn>
    </template>
  </v-data-table>
</div>
</template>

<script>

import axios from "axios";

export default {
	props: ['opt',],
  data: function() {
    return {
      search: '',
      carpeta_id: "",
      array_docs: [],
      headers: [
        { text: 'Id', sortable: true, value: 'id',},
        { text: 'Nombre', sortable: true, value: 'nombre',},
        { text: 'Grupo', sortable: true, value: 'agrupadorId',},
        { text: 'Estado', sortable: true, value: 'estado',},
        { text: 'Acciones', value: 'actions', sortable: false },
      ],
    };
  },
  computed: {
    
  },
  watch: {
    
  },
  created () {
    //console.log(this.$route);
    this.getDocuments();
  },
  mounted() {
  	console.log("opt: "+ this.opt+ ", carpeta_id: " + this.carpeta_id);
  },
  methods: {
    getDocuments() {
    	this.$store.dispatch('SET_OVERLAY');
      let getdoc = axios.get('AgrupadorFlujo/listar', { 'headers': this.$store.state.user.headers })
      return getdoc.then((callback) => {
        //console.log(callback.data);
        this.array_docs = callback.data;
        this.$store.dispatch('UNSET_OVERLAY');
      }).catch((error) => {
        this.$store.dispatch('UNSET_OVERLAY');
        console.log(error);
      });
    },
    deleteDocument(paquete_id, nombre_archivo) {
      console.log("Eliminar paquete: " + paquete_id);
      let r = confirm("¿Seguro de eliminar el documento " + nombre_archivo + " ?");
      if (r == true) 
      {
        this.$store.dispatch('SET_OVERLAY');
        let item_array = this.array_docs.findIndex(v => v.id == paquete_id);
        let getdoc = axios.delete('Paquete/Eliminar?id='+ paquete_id, { 'headers': this.$store.state.user.headers })
        return getdoc.then((callback) => {
          console.log(callback.status);
          this.$store.dispatch('UNSET_OVERLAY');
          if(callback.status == 200) {
            this.array_docs.splice(item_array, 1);
            this.$store.dispatch('SHOW_ERROR', {show: true, type: 'info', text: 'Documento eliminado con éxito.' });
          }else {
            this.$store.dispatch('SHOW_ERROR', {show: true, type: 'error', text: 'Hubo un error en el proceso.' });
          }
        }).catch((error) => {
          this.$store.dispatch('UNSET_OVERLAY');
          this.$store.dispatch('SHOW_ERROR', {show: true, type: 'error', text: 'Hubo un error en el proceso.' });
          console.log(error.response.data);
        });
      }
    },
  },
};
</script>